const GOOGLE_MAPS_BASE_URL = "https://maps.googleapis.com/maps/api/js"

export const SCRIPT_JS_BASE_PROPS = {
  loadingElement: <span>loading</span>,
  googleMapURL: `${GOOGLE_MAPS_BASE_URL}?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places`
}
